import React from "react";
import { Page } from "@shopify/polaris";

export function DashboardPage() {
    return <Page fullWidth title="Dashboard"></Page>;
}
